import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/txauth/common/session/session.proto" (package "proto.txauth.common.session", syntax proto3)
// tslint:disable
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "@finam/tx-proto-lib-google-wellknown/google/protobuf/timestamp_pb";
import { Lang } from "@finam/tx-proto-grpc-proto-common/proto/common/lang_pb";
import { Person } from "@finam/tx-proto-grpc-proto-common/proto/common/person_pb";
import { MarketDataPermissions } from "../permissions/txauth_marketdata_pb";
import { Account } from "@finam/tx-proto-grpc-proto-common/proto/common/account_pb";
/**
 * @generated from protobuf enum proto.txauth.common.session.Session.UserType
 */

export var Session_UserType;

(function (Session_UserType) {
  /**
   * @generated from protobuf enum value: UNKNOWN_USER_TYPE = 0;
   */
  Session_UserType[Session_UserType["UNKNOWN_USER_TYPE"] = 0] = "UNKNOWN_USER_TYPE";
  /**
   * Сотрудник
   *
   * @generated from protobuf enum value: EMPLOYEE_USER_TYPE = 1;
   */

  Session_UserType[Session_UserType["EMPLOYEE_USER_TYPE"] = 1] = "EMPLOYEE_USER_TYPE";
  /**
   * Клиент
   *
   * @generated from protobuf enum value: COMMON_USER_TYPE = 2;
   */

  Session_UserType[Session_UserType["COMMON_USER_TYPE"] = 2] = "COMMON_USER_TYPE";
  /**
   * Администратор
   *
   * @generated from protobuf enum value: ADMINISTRATOR_USER_TYPE = 3;
   */

  Session_UserType[Session_UserType["ADMINISTRATOR_USER_TYPE"] = 3] = "ADMINISTRATOR_USER_TYPE";
  /**
   * Представитель
   *
   * @generated from protobuf enum value: REPRESENTATIVE_USER_TYPE = 4;
   */

  Session_UserType[Session_UserType["REPRESENTATIVE_USER_TYPE"] = 4] = "REPRESENTATIVE_USER_TYPE";
  /**
   * Аноним (режим просмотра)
   *
   * @generated from protobuf enum value: ANONYMOUS_USER_TYPE = 5;
   */

  Session_UserType[Session_UserType["ANONYMOUS_USER_TYPE"] = 5] = "ANONYMOUS_USER_TYPE";
  /**
   * Демоторговец
   *
   * @generated from protobuf enum value: DEMO_USER_TYPE = 6;
   */

  Session_UserType[Session_UserType["DEMO_USER_TYPE"] = 6] = "DEMO_USER_TYPE";
  /**
   * Клиент в просессе регистрации
   *
   * @generated from protobuf enum value: UNTERCOMMON_USER_TYPE = 7;
   */

  Session_UserType[Session_UserType["UNTERCOMMON_USER_TYPE"] = 7] = "UNTERCOMMON_USER_TYPE";
})(Session_UserType || (Session_UserType = {}));
/**
 * @generated from protobuf enum proto.txauth.common.session.SessionProperties
 */


export var SessionProperties;

(function (SessionProperties) {
  /**
   * Наличие ключа означает что это демо-аккаунт.
   *
   * @generated from protobuf enum value: J2T_ONLINE_DEMO = 0;
   */
  SessionProperties[SessionProperties["J2T_ONLINE_DEMO"] = 0] = "J2T_ONLINE_DEMO";
  /**
   * ID фирм, которым принадлежит клиент, через запятую.
   *
   * @deprecated
   * @generated from protobuf enum value: EDOX_FIRMS = 1 [deprecated = true];
   */

  SessionProperties[SessionProperties["EDOX_FIRMS"] = 1] = "EDOX_FIRMS";
  /**
   * ID фирм, в которых клиент является квалифицированным инвестором, через запятую.
   * Ключ будет отсутствовать, если таких фирм нет.
   *
   * @deprecated
   * @generated from protobuf enum value: SOPHISTICATED_INVESTOR = 2 [deprecated = true];
   */

  SessionProperties[SessionProperties["SOPHISTICATED_INVESTOR"] = 2] = "SOPHISTICATED_INVESTOR";
  /**
   * Наличие ключа означает, что привязанный номер телефона подтверждён.
   * Дата в формате 2022-02-10T09:31:36.66Z
   *
   * @generated from protobuf enum value: PHONE_VERIFIED = 3;
   */

  SessionProperties[SessionProperties["PHONE_VERIFIED"] = 3] = "PHONE_VERIFIED";
})(SessionProperties || (SessionProperties = {}));
/**
 * @generated from protobuf enum proto.txauth.common.session.SessionContextKey
 */


export var SessionContextKey;

(function (SessionContextKey) {
  /**
   * @generated from protobuf enum value: CONTEXT_PLATFORM = 0;
   */
  SessionContextKey[SessionContextKey["CONTEXT_PLATFORM"] = 0] = "CONTEXT_PLATFORM";
  /**
   * @deprecated
   * @generated from protobuf enum value: CONTEXT_DEVICE_LOCAL_ID = 2 [deprecated = true];
   */

  SessionContextKey[SessionContextKey["CONTEXT_DEVICE_LOCAL_ID"] = 2] = "CONTEXT_DEVICE_LOCAL_ID";
  /**
   * id jwt-токена
   *
   * @generated from protobuf enum value: CONTEXT_TOKEN_ID = 3;
   */

  SessionContextKey[SessionContextKey["CONTEXT_TOKEN_ID"] = 3] = "CONTEXT_TOKEN_ID";
  /**
   * id ключей подписи и шифрования
   *
   * @generated from protobuf enum value: CONTEXT_DEVICE_KEY_ID = 4;
   */

  SessionContextKey[SessionContextKey["CONTEXT_DEVICE_KEY_ID"] = 4] = "CONTEXT_DEVICE_KEY_ID";
  /**
   * id родительского jwt-токена, или '' если только что авторизован
   *
   * @generated from protobuf enum value: CONTEXT_PARENT_TOKEN_ID = 5;
   */

  SessionContextKey[SessionContextKey["CONTEXT_PARENT_TOKEN_ID"] = 5] = "CONTEXT_PARENT_TOKEN_ID";
  /**
   * наличие ключа означает что устройство доверенное
   *
   * @generated from protobuf enum value: CONTEXT_DEVICE_VERIFIED = 6;
   */

  SessionContextKey[SessionContextKey["CONTEXT_DEVICE_VERIFIED"] = 6] = "CONTEXT_DEVICE_VERIFIED";
  /**
   * см. DeviceInfoKey.APP_NAME
   *
   * @generated from protobuf enum value: CONTEXT_DEVICE_APP_NAME = 7;
   */

  SessionContextKey[SessionContextKey["CONTEXT_DEVICE_APP_NAME"] = 7] = "CONTEXT_DEVICE_APP_NAME";
  /**
   * см. AuthSource.source
   *
   * @generated from protobuf enum value: CONTEXT_AUTH_SOURCE = 8;
   */

  SessionContextKey[SessionContextKey["CONTEXT_AUTH_SOURCE"] = 8] = "CONTEXT_AUTH_SOURCE";
  /**
   * см. AuthSource.ext
   *
   * @generated from protobuf enum value: CONTEXT_AUTH_SOURCE_EXT = 9;
   */

  SessionContextKey[SessionContextKey["CONTEXT_AUTH_SOURCE_EXT"] = 9] = "CONTEXT_AUTH_SOURCE_EXT";
  /**
   * см. DeviceInfoKey.APP_VERSION
   *
   * @generated from protobuf enum value: CONTEXT_DEVICE_APP_VERSION = 10;
   */

  SessionContextKey[SessionContextKey["CONTEXT_DEVICE_APP_VERSION"] = 10] = "CONTEXT_DEVICE_APP_VERSION";
})(SessionContextKey || (SessionContextKey = {}));
/**
 * @generated from protobuf enum proto.txauth.common.session.ServiceId
 */


export var ServiceId;

(function (ServiceId) {
  /**
   * дефолтное значение protobuf
   *
   * @generated from protobuf enum value: NO_SERVICE = 0;
   */
  ServiceId[ServiceId["NO_SERVICE"] = 0] = "NO_SERVICE";
  /**
   * @generated from protobuf enum value: FIX_TRADE = 1;
   */

  ServiceId[ServiceId["FIX_TRADE"] = 1] = "FIX_TRADE";
  /**
   * @generated from protobuf enum value: TRADE_INFO = 2;
   */

  ServiceId[ServiceId["TRADE_INFO"] = 2] = "TRADE_INFO";
  /**
   * @generated from protobuf enum value: TXTRADES = 3;
   */

  ServiceId[ServiceId["TXTRADES"] = 3] = "TXTRADES";
  /**
   * @generated from protobuf enum value: TXUSERFLOW = 4;
   */

  ServiceId[ServiceId["TXUSERFLOW"] = 4] = "TXUSERFLOW";
  /**
   * @generated from protobuf enum value: USA_API = 5;
   */

  ServiceId[ServiceId["USA_API"] = 5] = "USA_API";
  /**
   * любой сервис, принимающий авторизацию через Active Directory.
   * В качестве ключей параметров будут имена AD-групп, в которых состоит пользователь.
   *
   * @generated from protobuf enum value: AD = 6;
   */

  ServiceId[ServiceId["AD"] = 6] = "AD";
  /**
   * @generated from protobuf enum value: TXPROPTRADING = 7;
   */

  ServiceId[ServiceId["TXPROPTRADING"] = 7] = "TXPROPTRADING";
  /**
   * @generated from protobuf enum value: TXCHAT = 8;
   */

  ServiceId[ServiceId["TXCHAT"] = 8] = "TXCHAT";
  /**
   * @generated from protobuf enum value: J2T_GLOBAL = 9;
   */

  ServiceId[ServiceId["J2T_GLOBAL"] = 9] = "J2T_GLOBAL";
  /**
   * @generated from protobuf enum value: TXSCREENER = 10;
   */

  ServiceId[ServiceId["TXSCREENER"] = 10] = "TXSCREENER";
  /**
   * @generated from protobuf enum value: TXAUTH = 11;
   */

  ServiceId[ServiceId["TXAUTH"] = 11] = "TXAUTH";
  /**
   * @generated from protobuf enum value: TXNOTIFICATIONS = 12;
   */

  ServiceId[ServiceId["TXNOTIFICATIONS"] = 12] = "TXNOTIFICATIONS";
  /**
   * @generated from protobuf enum value: MARKET_DATA = 13;
   */

  ServiceId[ServiceId["MARKET_DATA"] = 13] = "MARKET_DATA";
  /**
   * @generated from protobuf enum value: TXORDERSHORN = 14;
   */

  ServiceId[ServiceId["TXORDERSHORN"] = 14] = "TXORDERSHORN";
  /**
   * @generated from protobuf enum value: MT5_TRADE = 15;
   */

  ServiceId[ServiceId["MT5_TRADE"] = 15] = "MT5_TRADE";
  /**
   * @generated from protobuf enum value: TXCABINET = 16;
   */

  ServiceId[ServiceId["TXCABINET"] = 16] = "TXCABINET";
  /**
   * @generated from protobuf enum value: TXBOFFICER = 17;
   */

  ServiceId[ServiceId["TXBOFFICER"] = 17] = "TXBOFFICER";
  /**
   * @generated from protobuf enum value: TXTA = 18;
   */

  ServiceId[ServiceId["TXTA"] = 18] = "TXTA";
  /**
   * @generated from protobuf enum value: TXSAVES = 19;
   */

  ServiceId[ServiceId["TXSAVES"] = 19] = "TXSAVES";
  /**
   * @generated from protobuf enum value: WATCHLIST = 20;
   */

  ServiceId[ServiceId["WATCHLIST"] = 20] = "WATCHLIST";
  /**
   * @generated from protobuf enum value: MACCESSOR = 21;
   */

  ServiceId[ServiceId["MACCESSOR"] = 21] = "MACCESSOR";
  /**
   * @generated from protobuf enum value: EDOX_PRODUCTS = 1001;
   */

  ServiceId[ServiceId["EDOX_PRODUCTS"] = 1001] = "EDOX_PRODUCTS";
  /**
   * @generated from protobuf enum value: EDOX_DOCUMENTS = 1002;
   */

  ServiceId[ServiceId["EDOX_DOCUMENTS"] = 1002] = "EDOX_DOCUMENTS";
  /**
   * @generated from protobuf enum value: EDOX_CONFIRMATION = 1003;
   */

  ServiceId[ServiceId["EDOX_CONFIRMATION"] = 1003] = "EDOX_CONFIRMATION";
  /**
   * @generated from protobuf enum value: EDOX_USERPROFILE = 1004;
   */

  ServiceId[ServiceId["EDOX_USERPROFILE"] = 1004] = "EDOX_USERPROFILE";
  /**
   * @generated from protobuf enum value: EDOX_NOTIFICATION = 1005;
   */

  ServiceId[ServiceId["EDOX_NOTIFICATION"] = 1005] = "EDOX_NOTIFICATION";
  /**
   * @generated from protobuf enum value: EDOX_ACCESS = 1006;
   */

  ServiceId[ServiceId["EDOX_ACCESS"] = 1006] = "EDOX_ACCESS";
  /**
   * @generated from protobuf enum value: EDOX_EMAIL = 1007;
   */

  ServiceId[ServiceId["EDOX_EMAIL"] = 1007] = "EDOX_EMAIL";
  /**
   * @generated from protobuf enum value: EDOX_QUESTIONNAIRE = 1008;
   */

  ServiceId[ServiceId["EDOX_QUESTIONNAIRE"] = 1008] = "EDOX_QUESTIONNAIRE";
  /**
   * @generated from protobuf enum value: EDOX_ACCOUNTFORM = 1009;
   */

  ServiceId[ServiceId["EDOX_ACCOUNTFORM"] = 1009] = "EDOX_ACCOUNTFORM";
  /**
   * @generated from protobuf enum value: EDOX_ACCOUNTS = 1010;
   */

  ServiceId[ServiceId["EDOX_ACCOUNTS"] = 1010] = "EDOX_ACCOUNTS";
  /**
   * @generated from protobuf enum value: EDOX_IMSI = 1011;
   */

  ServiceId[ServiceId["EDOX_IMSI"] = 1011] = "EDOX_IMSI";
  /**
   * @generated from protobuf enum value: EDOX_JOURNALS = 1012;
   */

  ServiceId[ServiceId["EDOX_JOURNALS"] = 1012] = "EDOX_JOURNALS";
  /**
   * @generated from protobuf enum value: EDOX_AGREEMENTS = 1013;
   */

  ServiceId[ServiceId["EDOX_AGREEMENTS"] = 1013] = "EDOX_AGREEMENTS";
  /**
   * @generated from protobuf enum value: EDOX_TAXES = 1014;
   */

  ServiceId[ServiceId["EDOX_TAXES"] = 1014] = "EDOX_TAXES";
  /**
   * @generated from protobuf enum value: EDOX_SECURITIES = 1016;
   */

  ServiceId[ServiceId["EDOX_SECURITIES"] = 1016] = "EDOX_SECURITIES";
  /**
   * @generated from protobuf enum value: EDOX_MONEYOUT = 1017;
   */

  ServiceId[ServiceId["EDOX_MONEYOUT"] = 1017] = "EDOX_MONEYOUT";
  /**
   * @generated from protobuf enum value: EDOX_ORDERS = 1018;
   */

  ServiceId[ServiceId["EDOX_ORDERS"] = 1018] = "EDOX_ORDERS";
  /**
   * @generated from protobuf enum value: EDOX_BALANCE_COSTS = 1019;
   */

  ServiceId[ServiceId["EDOX_BALANCE_COSTS"] = 1019] = "EDOX_BALANCE_COSTS";
  /**
   * @generated from protobuf enum value: EDOX_ACCOUNTS_DATA_STORAGE = 1200;
   */

  ServiceId[ServiceId["EDOX_ACCOUNTS_DATA_STORAGE"] = 1200] = "EDOX_ACCOUNTS_DATA_STORAGE";
  /**
   * @generated from protobuf enum value: GLOBAL_DATA = 2001;
   */

  ServiceId[ServiceId["GLOBAL_DATA"] = 2001] = "GLOBAL_DATA";
  /**
   * @generated from protobuf enum value: GLOBAL_BLACKLIST = 2002;
   */

  ServiceId[ServiceId["GLOBAL_BLACKLIST"] = 2002] = "GLOBAL_BLACKLIST";
  /**
   * @generated from protobuf enum value: CC_OVERDRAFT = 3001;
   */

  ServiceId[ServiceId["CC_OVERDRAFT"] = 3001] = "CC_OVERDRAFT";
  /**
   * @generated from protobuf enum value: EDOXAUTO_TSP_CONNECTOR = 4001;
   */

  ServiceId[ServiceId["EDOXAUTO_TSP_CONNECTOR"] = 4001] = "EDOXAUTO_TSP_CONNECTOR";
  /**
   * @generated from protobuf enum value: EDOXAUTO_PASSPORT_RECOGNIZER = 4002;
   */

  ServiceId[ServiceId["EDOXAUTO_PASSPORT_RECOGNIZER"] = 4002] = "EDOXAUTO_PASSPORT_RECOGNIZER";
})(ServiceId || (ServiceId = {}));
/**
 * @generated from protobuf enum proto.txauth.common.session.AuthMechanism
 */


export var AuthMechanism;

(function (AuthMechanism) {
  /**
   * @generated from protobuf enum value: UNKNOWN_MECHANISM = 0;
   */
  AuthMechanism[AuthMechanism["UNKNOWN_MECHANISM"] = 0] = "UNKNOWN_MECHANISM";
  /**
   * @generated from protobuf enum value: CREDS_MECHANISM = 1;
   */

  AuthMechanism[AuthMechanism["CREDS_MECHANISM"] = 1] = "CREDS_MECHANISM";
  /**
   * @generated from protobuf enum value: RENEW_MECHANISM = 2;
   */

  AuthMechanism[AuthMechanism["RENEW_MECHANISM"] = 2] = "RENEW_MECHANISM";
  /**
   * @generated from protobuf enum value: MANUAL_MECHANISM = 3;
   */

  AuthMechanism[AuthMechanism["MANUAL_MECHANISM"] = 3] = "MANUAL_MECHANISM";
  /**
   * @generated from protobuf enum value: ADMIN_MECHANISM = 4;
   */

  AuthMechanism[AuthMechanism["ADMIN_MECHANISM"] = 4] = "ADMIN_MECHANISM";
  /**
   * @generated from protobuf enum value: OTT_MECHANISM = 5;
   */

  AuthMechanism[AuthMechanism["OTT_MECHANISM"] = 5] = "OTT_MECHANISM";
  /**
   * @generated from protobuf enum value: QR_MECHANISM = 6;
   */

  AuthMechanism[AuthMechanism["QR_MECHANISM"] = 6] = "QR_MECHANISM";
  /**
   * @generated from protobuf enum value: OAUTH2_MECHANISM = 7;
   */

  AuthMechanism[AuthMechanism["OAUTH2_MECHANISM"] = 7] = "OAUTH2_MECHANISM";
})(AuthMechanism || (AuthMechanism = {})); // @generated message type with reflection information, may provide speed optimized methods


var EdoxFirm$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(EdoxFirm$Type, _MessageType);

  var _super = _createSuper(EdoxFirm$Type);

  function EdoxFirm$Type() {
    _classCallCheck(this, EdoxFirm$Type);

    return _super.call(this, "proto.txauth.common.session.EdoxFirm", [{
      no: 1,
      name: "id",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }, {
      no: 2,
      name: "qualified_investor",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }, {
      no: 3,
      name: "rating",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "manager_id",
      kind: "scalar",
      T: 3
      /*ScalarType.INT64*/

    }, {
      no: 5,
      name: "manager",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(EdoxFirm$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        id: 0,
        qualifiedInvestor: false,
        rating: "",
        managerId: "0",
        manager: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* int32 id */
          1:
            message.id = reader.int32();
            break;

          case
          /* bool qualified_investor */
          2:
            message.qualifiedInvestor = reader.bool();
            break;

          case
          /* string rating */
          3:
            message.rating = reader.string();
            break;

          case
          /* int64 manager_id */
          4:
            message.managerId = reader.int64().toString();
            break;

          case
          /* string manager */
          5:
            message.manager = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* int32 id = 1; */
      if (message.id !== 0) writer.tag(1, WireType.Varint).int32(message.id);
      /* bool qualified_investor = 2; */

      if (message.qualifiedInvestor !== false) writer.tag(2, WireType.Varint).bool(message.qualifiedInvestor);
      /* string rating = 3; */

      if (message.rating !== "") writer.tag(3, WireType.LengthDelimited).string(message.rating);
      /* int64 manager_id = 4; */

      if (message.managerId !== "0") writer.tag(4, WireType.Varint).int64(message.managerId);
      /* string manager = 5; */

      if (message.manager !== "") writer.tag(5, WireType.LengthDelimited).string(message.manager);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return EdoxFirm$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.txauth.common.session.EdoxFirm
 */


export var EdoxFirm = new EdoxFirm$Type(); // @generated message type with reflection information, may provide speed optimized methods

var Session$Type = /*#__PURE__*/function (_MessageType2) {
  _inherits(Session$Type, _MessageType2);

  var _super2 = _createSuper(Session$Type);

  function Session$Type() {
    _classCallCheck(this, Session$Type);

    return _super2.call(this, "proto.txauth.common.session.Session", [{
      no: 2,
      name: "accounts",
      kind: "message",
      repeat: 1
      /*RepeatType.PACKED*/
      ,
      T: function T() {
        return Account;
      }
    }, {
      no: 3,
      name: "permissions",
      kind: "message",
      repeat: 1
      /*RepeatType.PACKED*/
      ,
      T: function T() {
        return MarketDataPermissions;
      }
    }, {
      no: 4,
      name: "person",
      kind: "message",
      T: function T() {
        return Person;
      }
    }, {
      no: 6,
      name: "lang",
      kind: "enum",
      T: function T() {
        return ["proto.common.Lang", Lang];
      }
    }, {
      no: 12,
      name: "readonly",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }, {
      no: 16,
      name: "company_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 17,
      name: "user_type",
      kind: "enum",
      T: function T() {
        return ["proto.txauth.common.session.Session.UserType", Session_UserType];
      }
    }, {
      no: 18,
      name: "authentication_id",
      kind: "scalar",
      T: 3
      /*ScalarType.INT64*/

    }, {
      no: 19,
      name: "properties",
      kind: "map",
      K: 5
      /*ScalarType.INT32*/
      ,
      V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/

      }
    }, {
      no: 20,
      name: "firms",
      kind: "message",
      repeat: 1
      /*RepeatType.PACKED*/
      ,
      T: function T() {
        return EdoxFirm;
      }
    }, {
      no: 21,
      name: "crm_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 22,
      name: "edox_verified",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }, {
      no: 23,
      name: "translations",
      kind: "map",
      K: 9
      /*ScalarType.STRING*/
      ,
      V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/

      }
    }]);
  }

  _createClass(Session$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        accounts: [],
        permissions: [],
        lang: 0,
        readonly: false,
        companyId: "",
        userType: 0,
        authenticationId: "0",
        properties: {},
        firms: [],
        crmId: "",
        edoxVerified: false,
        translations: {}
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag3 = reader.tag(),
            _reader$tag4 = _slicedToArray(_reader$tag3, 2),
            fieldNo = _reader$tag4[0],
            wireType = _reader$tag4[1];

        switch (fieldNo) {
          case
          /* repeated proto.common.Account accounts */
          2:
            message.accounts.push(Account.internalBinaryRead(reader, reader.uint32(), options));
            break;

          case
          /* repeated proto.txauth.common.permissions.MarketDataPermissions permissions */
          3:
            message.permissions.push(MarketDataPermissions.internalBinaryRead(reader, reader.uint32(), options));
            break;

          case
          /* proto.common.Person person */
          4:
            message.person = Person.internalBinaryRead(reader, reader.uint32(), options, message.person);
            break;

          case
          /* proto.common.Lang lang */
          6:
            message.lang = reader.int32();
            break;

          case
          /* bool readonly */
          12:
            message.readonly = reader.bool();
            break;

          case
          /* string company_id */
          16:
            message.companyId = reader.string();
            break;

          case
          /* proto.txauth.common.session.Session.UserType user_type */
          17:
            message.userType = reader.int32();
            break;

          case
          /* int64 authentication_id */
          18:
            message.authenticationId = reader.int64().toString();
            break;

          case
          /* map<int32, string> properties */
          19:
            this.binaryReadMap19(message.properties, reader, options);
            break;

          case
          /* repeated proto.txauth.common.session.EdoxFirm firms */
          20:
            message.firms.push(EdoxFirm.internalBinaryRead(reader, reader.uint32(), options));
            break;

          case
          /* string crm_id */
          21:
            message.crmId = reader.string();
            break;

          case
          /* bool edox_verified */
          22:
            message.edoxVerified = reader.bool();
            break;

          case
          /* map<string, string> translations */
          23:
            this.binaryReadMap23(message.translations, reader, options);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "binaryReadMap19",
    value: function binaryReadMap19(map, reader, options) {
      var len = reader.uint32(),
          end = reader.pos + len,
          key,
          val;

      while (reader.pos < end) {
        var _reader$tag5 = reader.tag(),
            _reader$tag6 = _slicedToArray(_reader$tag5, 2),
            fieldNo = _reader$tag6[0],
            wireType = _reader$tag6[1];

        switch (fieldNo) {
          case 1:
            key = reader.int32();
            break;

          case 2:
            val = reader.string();
            break;

          default:
            throw new globalThis.Error("unknown map entry field for field proto.txauth.common.session.Session.properties");
        }
      }

      map[key !== null && key !== void 0 ? key : 0] = val !== null && val !== void 0 ? val : "";
    }
  }, {
    key: "binaryReadMap23",
    value: function binaryReadMap23(map, reader, options) {
      var len = reader.uint32(),
          end = reader.pos + len,
          key,
          val;

      while (reader.pos < end) {
        var _reader$tag7 = reader.tag(),
            _reader$tag8 = _slicedToArray(_reader$tag7, 2),
            fieldNo = _reader$tag8[0],
            wireType = _reader$tag8[1];

        switch (fieldNo) {
          case 1:
            key = reader.string();
            break;

          case 2:
            val = reader.string();
            break;

          default:
            throw new globalThis.Error("unknown map entry field for field proto.txauth.common.session.Session.translations");
        }
      }

      map[key !== null && key !== void 0 ? key : ""] = val !== null && val !== void 0 ? val : "";
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* repeated proto.common.Account accounts = 2; */
      for (var i = 0; i < message.accounts.length; i++) {
        Account.internalBinaryWrite(message.accounts[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
      }
      /* repeated proto.txauth.common.permissions.MarketDataPermissions permissions = 3; */


      for (var _i = 0; _i < message.permissions.length; _i++) {
        MarketDataPermissions.internalBinaryWrite(message.permissions[_i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
      }
      /* proto.common.Person person = 4; */


      if (message.person) Person.internalBinaryWrite(message.person, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      /* proto.common.Lang lang = 6; */

      if (message.lang !== 0) writer.tag(6, WireType.Varint).int32(message.lang);
      /* bool readonly = 12; */

      if (message.readonly !== false) writer.tag(12, WireType.Varint).bool(message.readonly);
      /* string company_id = 16; */

      if (message.companyId !== "") writer.tag(16, WireType.LengthDelimited).string(message.companyId);
      /* proto.txauth.common.session.Session.UserType user_type = 17; */

      if (message.userType !== 0) writer.tag(17, WireType.Varint).int32(message.userType);
      /* int64 authentication_id = 18; */

      if (message.authenticationId !== "0") writer.tag(18, WireType.Varint).int64(message.authenticationId);
      /* map<int32, string> properties = 19; */

      for (var _i2 = 0, _Object$keys = Object.keys(message.properties); _i2 < _Object$keys.length; _i2++) {
        var k = _Object$keys[_i2];
        writer.tag(19, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.properties[k]).join();
      }
      /* repeated proto.txauth.common.session.EdoxFirm firms = 20; */


      for (var _i3 = 0; _i3 < message.firms.length; _i3++) {
        EdoxFirm.internalBinaryWrite(message.firms[_i3], writer.tag(20, WireType.LengthDelimited).fork(), options).join();
      }
      /* string crm_id = 21; */


      if (message.crmId !== "") writer.tag(21, WireType.LengthDelimited).string(message.crmId);
      /* bool edox_verified = 22; */

      if (message.edoxVerified !== false) writer.tag(22, WireType.Varint).bool(message.edoxVerified);
      /* map<string, string> translations = 23; */

      for (var _i4 = 0, _Object$keys2 = Object.keys(message.translations); _i4 < _Object$keys2.length; _i4++) {
        var _k = _Object$keys2[_i4];
        writer.tag(23, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(_k).tag(2, WireType.LengthDelimited).string(message.translations[_k]).join();
      }

      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return Session$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.txauth.common.session.Session
 */


export var Session = new Session$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ExclusiveRights$Type = /*#__PURE__*/function (_MessageType3) {
  _inherits(ExclusiveRights$Type, _MessageType3);

  var _super3 = _createSuper(ExclusiveRights$Type);

  function ExclusiveRights$Type() {
    _classCallCheck(this, ExclusiveRights$Type);

    return _super3.call(this, "proto.txauth.common.session.ExclusiveRights", [{
      no: 1,
      name: "params",
      kind: "map",
      K: 9
      /*ScalarType.STRING*/
      ,
      V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/

      }
    }]);
  }

  _createClass(ExclusiveRights$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        params: {}
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag9 = reader.tag(),
            _reader$tag10 = _slicedToArray(_reader$tag9, 2),
            fieldNo = _reader$tag10[0],
            wireType = _reader$tag10[1];

        switch (fieldNo) {
          case
          /* map<string, string> params */
          1:
            this.binaryReadMap1(message.params, reader, options);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "binaryReadMap1",
    value: function binaryReadMap1(map, reader, options) {
      var len = reader.uint32(),
          end = reader.pos + len,
          key,
          val;

      while (reader.pos < end) {
        var _reader$tag11 = reader.tag(),
            _reader$tag12 = _slicedToArray(_reader$tag11, 2),
            fieldNo = _reader$tag12[0],
            wireType = _reader$tag12[1];

        switch (fieldNo) {
          case 1:
            key = reader.string();
            break;

          case 2:
            val = reader.string();
            break;

          default:
            throw new globalThis.Error("unknown map entry field for field proto.txauth.common.session.ExclusiveRights.params");
        }
      }

      map[key !== null && key !== void 0 ? key : ""] = val !== null && val !== void 0 ? val : "";
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* map<string, string> params = 1; */
      for (var _i5 = 0, _Object$keys3 = Object.keys(message.params); _i5 < _Object$keys3.length; _i5++) {
        var k = _Object$keys3[_i5];
        writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.params[k]).join();
      }

      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ExclusiveRights$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.txauth.common.session.ExclusiveRights
 */


export var ExclusiveRights = new ExclusiveRights$Type(); // @generated message type with reflection information, may provide speed optimized methods

var SessionContext$Type = /*#__PURE__*/function (_MessageType4) {
  _inherits(SessionContext$Type, _MessageType4);

  var _super4 = _createSuper(SessionContext$Type);

  function SessionContext$Type() {
    _classCallCheck(this, SessionContext$Type);

    return _super4.call(this, "proto.txauth.common.session.SessionContext", [{
      no: 1,
      name: "context",
      kind: "map",
      K: 5
      /*ScalarType.INT32*/
      ,
      V: {
        kind: "scalar",
        T: 9
        /*ScalarType.STRING*/

      }
    }, {
      no: 2,
      name: "exclusive_rights",
      kind: "map",
      K: 5
      /*ScalarType.INT32*/
      ,
      V: {
        kind: "message",
        T: function T() {
          return ExclusiveRights;
        }
      }
    }, {
      no: 3,
      name: "updated",
      kind: "message",
      T: function T() {
        return Timestamp;
      }
    }, {
      no: 4,
      name: "expired",
      kind: "message",
      T: function T() {
        return Timestamp;
      }
    }]);
  }

  _createClass(SessionContext$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        context: {},
        exclusiveRights: {}
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag13 = reader.tag(),
            _reader$tag14 = _slicedToArray(_reader$tag13, 2),
            fieldNo = _reader$tag14[0],
            wireType = _reader$tag14[1];

        switch (fieldNo) {
          case
          /* map<int32, string> context */
          1:
            this.binaryReadMap1(message.context, reader, options);
            break;

          case
          /* map<int32, proto.txauth.common.session.ExclusiveRights> exclusive_rights */
          2:
            this.binaryReadMap2(message.exclusiveRights, reader, options);
            break;

          case
          /* google.protobuf.Timestamp updated */
          3:
            message.updated = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updated);
            break;

          case
          /* google.protobuf.Timestamp expired */
          4:
            message.expired = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expired);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "binaryReadMap1",
    value: function binaryReadMap1(map, reader, options) {
      var len = reader.uint32(),
          end = reader.pos + len,
          key,
          val;

      while (reader.pos < end) {
        var _reader$tag15 = reader.tag(),
            _reader$tag16 = _slicedToArray(_reader$tag15, 2),
            fieldNo = _reader$tag16[0],
            wireType = _reader$tag16[1];

        switch (fieldNo) {
          case 1:
            key = reader.int32();
            break;

          case 2:
            val = reader.string();
            break;

          default:
            throw new globalThis.Error("unknown map entry field for field proto.txauth.common.session.SessionContext.context");
        }
      }

      map[key !== null && key !== void 0 ? key : 0] = val !== null && val !== void 0 ? val : "";
    }
  }, {
    key: "binaryReadMap2",
    value: function binaryReadMap2(map, reader, options) {
      var len = reader.uint32(),
          end = reader.pos + len,
          key,
          val;

      while (reader.pos < end) {
        var _reader$tag17 = reader.tag(),
            _reader$tag18 = _slicedToArray(_reader$tag17, 2),
            fieldNo = _reader$tag18[0],
            wireType = _reader$tag18[1];

        switch (fieldNo) {
          case 1:
            key = reader.int32();
            break;

          case 2:
            val = ExclusiveRights.internalBinaryRead(reader, reader.uint32(), options);
            break;

          default:
            throw new globalThis.Error("unknown map entry field for field proto.txauth.common.session.SessionContext.exclusive_rights");
        }
      }

      map[key !== null && key !== void 0 ? key : 0] = val !== null && val !== void 0 ? val : ExclusiveRights.create();
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* map<int32, string> context = 1; */
      for (var _i6 = 0, _Object$keys4 = Object.keys(message.context); _i6 < _Object$keys4.length; _i6++) {
        var k = _Object$keys4[_i6];
        writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.context[k]).join();
      }
      /* map<int32, proto.txauth.common.session.ExclusiveRights> exclusive_rights = 2; */


      for (var _i7 = 0, _Object$keys5 = Object.keys(message.exclusiveRights); _i7 < _Object$keys5.length; _i7++) {
        var _k2 = _Object$keys5[_i7];
        writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(_k2));
        writer.tag(2, WireType.LengthDelimited).fork();
        ExclusiveRights.internalBinaryWrite(message.exclusiveRights[_k2], writer, options);
        writer.join().join();
      }
      /* google.protobuf.Timestamp updated = 3; */


      if (message.updated) Timestamp.internalBinaryWrite(message.updated, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
      /* google.protobuf.Timestamp expired = 4; */

      if (message.expired) Timestamp.internalBinaryWrite(message.expired, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return SessionContext$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.txauth.common.session.SessionContext
 */


export var SessionContext = new SessionContext$Type();